import { useEffect } from "react";
import { InteractionManager } from "react-native";

import { isLocal, isTest } from "@/config/env";

let hasInitialized = false;

export default function useInitializeSentryIntegrations() {
  useEffect(() => {
    if (isLocal || isTest || hasInitialized) return;
    hasInitialized = true;
    const task = InteractionManager.runAfterInteractions(() => {
      import("../sentry.integrations").then((sentry) =>
        sentry.loadSentryIntegrations(),
      );
    });
    return task.cancel;
  }, []);
  return null;
}
